module.exports = __webpack_public_path__ + "img/fundo.df8e34bc.png";